import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  TableContainer,
  Table,
  Box,
  Button,
  Grid,
} from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import ClientService from '../../services/ClientService.jsx';
import TowersTable from './TowersTable.jsx';
import VerifyDialog from './VerifyDialog.jsx';
import VerifyActionsDialog from './VerifyActionsDialog.jsx';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: '0 5px',
    },
  },
  table: {
    minWidth: 650,
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
}));

export default function Towers() {
  const classes = useStyles();
  const [openVerify, setOpenVerify] = React.useState(false);
  const [openVerifyActions, setOpenVerifyActions] = React.useState(false);
  const [data, setData] = useState([]);
  const [dataFetching, setDataFetching] = useState(false);
  const [verification, setVerification] = useState(false);
  const [verified, setVerified] = useState(null);
  const [verifiedActions, setVerifiedActions] = useState(null);
  // const [actionsVerified, setActionsVerified] = useState(null);
  const [ethId, setEthId] = useState(null);
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleClickOpen = () => {
    setOpenVerify(true);
  };

  const handleClose = () => {
    setOpenVerify(false);
    setVerified(null);
  };


  const handleOpenVerifyActions = (towerEthId) => {
    setEthId(towerEthId);
    setOpenVerifyActions(true);
  };

  const handleCloseVerifyActions = () => {
    setEthId(null);
    setVerifiedActions(null);
    setOpenVerifyActions(false);
  };

  const loadTowers = async () => {
    try {
      setDataFetching(true);
      const towers = await ClientService.getTowers();
      setData(towers.sort((a, b) => (a.ethId - b.ethId)));
      setDataFetching(false);
    } catch (err) {
      setDataFetching(false);
      throw new Error(err.message);
    }
  };

  const verifyTowers = async () => {
    try {
      setVerification(true);
      const result = await ClientService.verifyListOfTowers();
      setVerified(result);
      setVerification(false);
    } catch (err) {
      setVerification(false);
      throw new Error(err.message);
    }
  };

  const verifyActions = async () => {
    try {
      setVerification(true);
      const result = await ClientService.verifyActionsByTower(ethId);
      setVerifiedActions(result);
      setVerification(false);
    } catch (err) {
      setVerification(false);
      throw new Error(err.message);
    }
  };

  const verifyMultipleTowers = async () => {
    alert('not');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const loadText = (data.length !== 0) ? 'Reload' : 'Load';

  const towers = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const isSelected = (id) => selected.indexOf(id) !== -1;

  return (
    <React.Fragment>
      <VerifyDialog
        open={openVerify}
        handleClose={handleClose}
        handleVerify={verifyTowers}
        verification={verification}
        verified={verified}
      />
      <VerifyActionsDialog
        open={openVerifyActions}
        handleClose={handleCloseVerifyActions}
        handleVerify={verifyActions}
        verification={verification}
        verified={verifiedActions}
        ethId={ethId}
      />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <div className={classes.root}>
            <Button variant="contained" color="primary" onClick={loadTowers} disabled={dataFetching}>{(!dataFetching) ? loadText : 'Loading...'}</Button>
            {
              (selected.length === 0)
              && <Button variant="contained" color="secondary" onClick={handleClickOpen}>Verify towers</Button>
            }
            {
              (selected.length > 0)
              && <Button variant="contained" color="secondary" onClick={handleClickOpen}>Verify actions</Button>
            }
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper} variant="outlined">
            <Table className={classes.table} size="medium">
                <TowersTable
                  data={towers}
                  handleOpen={handleOpenVerifyActions}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  emptyRows={emptyRows}
                  isSelected={isSelected}
                  numSelected={selected.length}
                  rowCount={data.length}
                  onSelectAllClick={handleSelectAllClick}
                  handleRowClick={handleClick}
                />
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 15, 20]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
